export const configs = {
  FOOTER_PAGE_ID: {
    en: 169,
    vi: 205,
  },
  HEADER_PAGE_ID: {
    vi: 19,
    en: 16,
  },
  DEFAULT_SLUG: {
    en: "trang-chu-caocaoadventures",
    vi: "trang-chu-caocaoadventures-vi",
  },
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
}
